export { default } from './RecentlyReturnedTitle';



// WEBPACK FOOTER //
// ./app/components/borrowing/recentlyreturned/RecentlyReturnedTitle/index.js